import { apiClient } from "@/lib/api-client";

export const getIku6 = async (
  niu: string,
  year: string | number,
  semester: string | number,
  periodeID: string | number,
  month?: string | null,
) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const params = new URLSearchParams({
    year: String(year),
    semester: String(semester),
    periodeID: String(periodeID),
  });
  if (month) {
    params.append("month", month);
  }
  const response = await apiClient<any>(
    `${baseUrl}/api/v1/unsur-penelitian/${niu}/iku-6?${params.toString()}`,
  );

  return response;
};

export const getIku4 = async (
  niu: string,
  year: string | number,
  semester: string | number,
  periodeID: string | number,
  month?: string | null,
) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const params = new URLSearchParams({
    year: String(year),
    semester: String(semester),
    periodeID: String(periodeID),
  });
  if (month) {
    params.append("month", month);
  }
  const response = await apiClient<any>(
    `${baseUrl}/api/v1/unsur-penelitian/${niu}/iku-4?${params.toString()}`,
  );

  return response;
};

export const getIku5 = async (
  niu: string,
  year: string | number,
  semester: string | number,
  periodeID: string | number,
  month?: string | null,
) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const params = new URLSearchParams({
    year: String(year),
    semester: String(semester),
    periodeID: String(periodeID),
  });
  if (month) {
    params.append("month", month);
  }
  const response = await apiClient<any>(
    `${baseUrl}/api/v1/unsur-penelitian/${niu}/iku-5?${params.toString()}`,
  );

  return response;
};

export const getIku7 = async (
  niu: string,
  year: string | number,
  semester: string | number,
  periodeID: string | number,
  month?: string | null,
) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const params = new URLSearchParams({
    year: String(year),
    semester: String(semester),
    periodeID: String(periodeID),
  });
  if (month) {
    params.append("month", month);
  }
  const response = await apiClient<any>(
    `${baseUrl}/api/v1/unsur-penelitian/${niu}/iku-7?${params.toString()}`,
  );

  return response;
};

export const getIku8 = async (
  niu: string,
  year: string | number,
  semester: string | number,
  periodeID: string | number,
  month?: string | null,
) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const params = new URLSearchParams({
    year: String(year),
    semester: String(semester),
    periodeID: String(periodeID),
  });
  if (month) {
    params.append("month", month);
  }
  const response = await apiClient<any>(
    `${baseUrl}/api/v1/unsur-penelitian/${niu}/iku-8?${params.toString()}`,
  );

  return response;
};
